import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { ThumbsUp, X } from "lucide-react";
import ImageProfil from "../Profil/ImageProfil";

const ReactionsModal = ({ open, onClose, users }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const onEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onEscape);
    return () => document.removeEventListener("keydown", onEscape);
  }, [open, onClose]);

  if (!open) return null;

  const openProfile = (id) => {
    onClose();
    navigate(`/userprofil/${id}`);
  };

  return createPortal(
    <div
      className="palette-overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="palette reactions-modal" role="dialog" aria-label="Réactions">
        <div className="reactions-head">
          <span className="reactions-title">
            <ThumbsUp size={15} />
            Réactions
          </span>
          <span className="reactions-count">
            {users.length} {users.length > 1 ? "personnes" : "personne"}
          </span>
          <button className="palette-close" onClick={onClose} aria-label="Fermer">
            <X size={15} />
          </button>
        </div>

        <div className="palette-results">
          <ul>
            {users.map((user) => (
              <li key={user.id} onClick={() => openProfile(user.id)}>
                <span className="avatar">
                  <span className="avatar-initials">
                    {(user.firstname?.[0] || "") + (user.name?.[0] || "")}
                  </span>
                  <ImageProfil id={user.id} />
                </span>
                <span className="palette-user">
                  <span className="palette-user-name">
                    {user.firstname} {user.name}
                  </span>
                  {user.service && (
                    <span className="palette-user-service">{user.service}</span>
                  )}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ReactionsModal;
